<template>
  <el-container style='padding: 20px'>

    <el-header style='line-height: 80px;height: 80px;'>
      <span class='left-table'>站点名称：</span>
      <el-input v-model='station_name' placeholder='请输入站点名称'
                style='width: 210px;margin-right: 10px;'></el-input>
      <span class='left-table'>机柜编号：</span>
      <el-input v-model='cabinet_id' placeholder='请输入机柜编号'
                style='width: 210px;margin-right: 10px;'></el-input>
      <span class='left-table'>自定义编号：</span>
      <el-input v-model='cabinet_code' placeholder='请输入自定义编号'
                style='width: 210px;margin-right: 10px;'></el-input>
      <el-button type='primary' icon='el-icon-search' @click='find'>查询</el-button>
    </el-header>

    <el-main style='background: #fff;'>
      <el-table
        ref='devTable'
        :data='tableData' v-loading='loading' stripe
        :default-sort="{prop: 'date', order: 'descending'}"
        @row-dblclick='handleDetailClick'>
        <el-table-column type='index' label='序号' width='50'></el-table-column>
        <el-table-column prop='station_name' label='站点名称' show-overflow-tooltip>
          <template slot-scope='scope'>
            <div v-if='(scope.row.station_name.length <=0)' style='color:#F56C6C'>
              --未绑定站点--
            </div>
            <div v-else>{{ scope.row.station_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop='id' label='机柜编号' show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop='code' label='自定义编号' show-overflow-tooltip>
          <template slot-scope='scope'>
            <div v-if='(scope.row.code.length <=0)' style='color:#F56C6C'>
              --未自定义--
            </div>
            <div v-else> {{ scope.row.code }}</div>
          </template>
        </el-table-column>

        <el-table-column prop='bat_u' label='电池电压'>
          <template slot-scope='scope'>
            {{ (scope.row.bat_u / 100).toFixed(2) }} V
          </template>
        </el-table-column>

        <el-table-column prop='bi' label='水箱水位' show-overflow-tooltip>
          <template slot-scope='scope'>
            <div v-if='parseWaterLevel(scope.row.bi).length>0' style='color:#F56C6C'>
             {{ parseWaterLevel(scope.row.bi)}}
            </div>
            <div v-else style='color:#67C23A'>
              正常
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bo' label='水泵状态'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0002)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bo' label='柜照明灯'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0001)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='bo' label='柜内风扇'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0008)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bo' label='补水电磁阀'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0010)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bo' label='充电仓喷淋'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0020)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bo' label='充电插座喷淋'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bo&0x0040)>0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='bi' label='机柜后门'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.bi&0x8000)<=0' style='color:#F56C6C'>
              开启
            </div>
            <div v-else style='color:#67C23A'>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='stat' label='消防灯' show-overflow-tooltip>
          <template slot-scope='scope'>
            <div v-if='(scope.row.stat&0x0001)>0' style='color:#E65D6E'>
              红色灯亮
            </div>
            <div v-else-if='(scope.row.stat&0x0002)>0' style='color:green'>
              绿色灯亮
            </div>
            <div v-else-if='(scope.row.stat&0x0004)>0' style='color:sandybrown'>
              黄色灯亮
            </div>
            <div v-else>
              关闭
            </div>
          </template>
        </el-table-column>

        <el-table-column prop='stat' label='急停按钮'>
          <template slot-scope='scope'>
            <div v-if='(scope.row.stat&0x0100)>0' style='color:#E65D6E'>
              已按
            </div>
            <div v-else style='color:#67C23A'>
              未按
            </div>
          </template>
        </el-table-column>


        <el-table-column prop='com' label='串口通信' show-overflow-tooltip>
          <template slot-scope='scope'>
            <div v-if='(scope.row.com&0x01)>0' style='color:#E65D6E'>-柜控板故障-
            </div>
            <div v-else-if='(scope.row.com&0x02)>0' style='color:#E65D6E'>
              -终端板故障-
            </div>
            <div v-else style='color:#67C23A'>
              正常
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='updated_at' label='是否在线'>
          <template slot-scope='scope'>
            <div v-if='(diffDate(scope.row.updated_at)/1000)>120' style='color:#F56C6C' class='blink'>离线</div>
            <div v-else style='color:#67C23A'>在线</div>
          </template>
        </el-table-column>
        <el-table-column prop='updated_at' label='更新时间' width='160'></el-table-column>
        <el-table-column prop='enable' label='是否启用'>
          <template slot-scope='scope'>
            <div v-if='scope.row.enable==1' style='color:#E65D6E'>
              禁用
            </div>
            <div v-else style='color:#67C23A'>
              启用
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='ip' label='IP'/>
        <el-table-column label='操作' width='180'>
          <template slot-scope='scope'>
            <el-tooltip class='item' effect='dark' content='机柜二维码' placement='top'>
              <el-button type='text' @click='handleQRCodeClick(scope.row)'>
                <svg-icon icon-class='ali_qrcode'></svg-icon>
              </el-button>
            </el-tooltip>
            <el-tooltip class='item' effect='dark' content='机柜详情' placement='top'>
              <el-button type='text' @click='handleDetailClick(scope.row)'>
                <svg-icon icon-class='ali_cabinet'></svg-icon>
              </el-button>
            </el-tooltip>
            <el-tooltip class='item' effect='dark' content='编辑' placement='top'>
              <el-button icon='el-icon-edit' type='text'
                         @click='handleSettingClick(scope.row)'></el-button>
            </el-tooltip>
            <!--            <el-tooltip class='item' effect='dark' content='删除' placement='top'>-->
            <!--              <el-button icon='el-icon-delete' type='text'-->
            <!--                         @click='handleDeleteClick(scope.row)'></el-button>-->
            <!--            </el-tooltip>-->
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer align='center' style='align-items: center; display: inherit;'>
      <el-pagination
        background
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='pagination.page_no'
        :page-sizes='[28, 30, 40, 50]'
        :page-size='28'
        layout='total, sizes, prev, pager, next'
        :total='pagination.count'
      ></el-pagination>
    </el-footer>

    <!-- 编辑 -->
    <el-dialog title='编辑信息' :visible.sync='editVisible' width='25%' @closed='closeDialog'>
      <el-form label-width='120px' ref='form' :rules='rules' :model='form'>

        <el-form-item label='机柜编号' prop='id'>
          <el-input t v-model='form.id' disabled placeholder='请输入机柜编号'></el-input>
        </el-form-item>

        <el-form-item label='站点名称' prop='station_name'>
          <el-autocomplete style='width: 100%'
                           v-model='form.station_name'
                           :fetch-suggestions='querySearchAsync'
                           placeholder='请输入站点名称'
                           @select='handleSelectStation'
          ></el-autocomplete>
        </el-form-item>

        <el-form-item label='是否启用' prop='enable'>
          <el-select v-model='form.enable' placeholder='请选择' style='width:100%;'>
            <el-option
              v-for='item in enableOptions'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label='自定义编号' prop='code'>
          <el-input t v-model='form.code' placeholder='请输入自定义编号'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设备详情 -->
    <el-dialog :title="'二维码内容:'+ QRCodeIDs[0]+''" :visible.sync='qrcodeVisible' width='40%' @closed='closeQRCodeDialog'>

      <div style='margin-top: 20px;' class='min'>
        <!--存放二维码-->
        <div class='qrcode one' id='qrcode' ref='qrCodeUrl' style='margin-top:20px; '></div>
      </div>

      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeQRCodeDialog'>关 闭</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='downLoadQrCode'>下 载</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { gateway } from '@/api/admin.js'
import ElContainer from '../../../node_modules/element-ui/packages/container/src/main.vue'
import QRCode from 'qrcodejs2'

export default {
  name: 'monitoring',
  components: { ElContainer },
  data() {
    return {

      //*******设备信息
      cabinet_id: null,
      station_name: null,
      cabinet_code: null,
      tableData: [],
      editVisible: false,
      form: {},
      rules: {
        station_name: [
          { required: true, message: '请输入站点名称', trigger: 'blur' }
        ]
      },
      //***********设备二维码
      qrcodeVisible: false,
      QRCodeIDs: [],
      QRCodeURL: [],            //存放生成的二维码图片地址

      //设备详情
      detailVisible: false,


      cmdVisible: false,
      isDisabled: true,
      cmdForm: {
        ctrl: null,
        device_id: null,
        sn: null,
        cn: null,
        box_sn: null,
        duration: null,
        code: null
      },
      cabinets: [],
      grids: [],
      controls: [],
      clients: [],
      channels: [],
      ac_channels: [],
      show: {
        loading: false
      },
      pagination: {
        page_size: 28, //页面数据条数
        page_no: 1, //页号
        count: 30
      },
      enableOptions: [
        {
          value: 0,
          label: '启用'
        },
        {
          value: 1,
          label: '禁用'
        }
      ]
    }
  },
  created() {
    this.station_id = this.$route.query.station_id
    this.getTableData()
  },
  watch: {
    tableData: function() {
      this.$nextTick(function() {
        //this.$refs.devTable.setCurrentRow(this.tableData[0])
      })
    }
  },
  methods: {

    getTableData() {
      this.loading = true
      let str = JSON.stringify({
        cabinet_code: this.cabinet_code,
        cabinet_id: parseInt(this.cabinet_id),
        station_name: this.station_name,
        station_id: this.station_id
      })
      gateway({
        func: 'get_cabinet_list',
        page_no: this.pagination.page_no,
        page_size: this.pagination.page_size,
        params: str
      }).then(res => {
        this.loading = false
        this.tableData = res.result
        this.pagination.count = res.count
      })
    },

    // 点击跳转页数
    handleCurrentChange(val) {
      this.pagination.page_no = val
      this.getTableData()
    },

    handleSizeChange(val) {
      this.pagination.page_size = val
      this.getTableData()
    },

    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.form = {}
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    handleSettingClick(row) {
      this.editVisible = true
      this.form = Object.assign({
        id: row.id,
        station_id: row.station_id,
        station_name: row.station_name,
        code: row.code,
        enable: row.enable
      })
    },

    handleDeleteClick(row) {
      this.$confirm('是否删除设备：' + row.id + ' ？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_cabinet',
          params: str
        }).then(() => {
          this.getRole()
        })

      }).catch(() => {
      })
    },

    /** 远程搜索客户操作 */
    querySearchAsync(queryString, cb) {

      var name = null
      this.form.station_id = null
      if (queryString !== '') {
        name = queryString
      }

      let str = JSON.stringify({
        page_no: 1,
        page_size: 30,
        name: name
      })

      gateway({
        func: 'get_station_list',
        params: str
      }).then(res => {
        this.stations = []
        for (var i = 0; i < res.result.length; i++) {
          var item = {
            value: res.result[i].name,
            id: res.result[i].id
          }
          this.stations.push(item)
        }
        cb(this.stations)
      })
    },
    /** 点击远程搜索返回站点的选择操作 */
    handleSelectStation(item) {
      this.form.station_id = item.id
      this.form.station_name = item.value
    },
    //修改
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          var params = {}
          if (this.isEdit) {
            params = {
              station_id: this.form.station_id,
              code: this.form.code,
              enable: this.form.enable
            }
          } else {
            params = this.form
          }
          gateway({
            func: 'set_cabinet',
            params: JSON.stringify(params)
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('编辑信息成功')
              this.closeDialog()
              this.getTableData()
            } else {
              this.$message.warning(res.msg)

            }
          })
        } else {
          return false
        }
      })
    },


    //*************************************************************************************
    //***************************************************设备二维码*************************
    //*************************************************************************************
    //关闭对话框
    closeQRCodeDialog() {
      this.qrcodeVisible = false
    },

    handleQRCodeClick(row) {
      this.qrcodeVisible = true
      setTimeout(() => {
        this.QRCodeIDs = []
        this.QRCodeIDs.push(this.$global.URL.cabinet + row.id)
        this.createQrCode()
      }, 1000)
    },
    // 生成二维码
    createQrCode() {
      document.querySelector('.qrcode').innerHTML = ''  // 清空div中的二维码图片
      this.QRCodeIDs.forEach((each) => {                       // 循环创建二维码
        new QRCode(this.$refs.qrCodeUrl, {             // 将创建好的二维码图片放在div中
          text: each,                                  // 需要转换为二维码的内容
          width: 500,
          height: 500,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    downLoadQrCode() {
      var img = document.querySelectorAll('.qrcode img')
      for (var i = 0; i < img.length; i++) {
        var url = img[i].src
        var a = document.createElement('a')
        var event = new MouseEvent('click') // 创建一个单击事件
        a.href = url
        a.download = this.QRCodeIDs[i] + '.png'// 图片名称
        a.dispatchEvent(event) // 触发a的单击事件
      }
    },
    //*************************************************************************************
    //***************************************************设备详情*************************
    //*************************************************************************************
    //关闭对话框
    closeDetailDialog() {
      this.detailVisible = false
    },

    handleDetailClick(row) {
      // this.detailVisible = true
      this.$router.push({ path: '/agencyMgt/cabinet_detail', query: { cabinet_id: row.id } })
    },
    // rowClick(row, column, event) {
    //   this.$router.push({ path: '/agencyMgt/cabinet_detail',query: {cabinet_id:row.id} })
    //   // this.clients = row.clients
    //   // // this.controls = row.controls
    //   // this.ac_channels = []
    //   //
    //   //
    //   // if (row.controls != null) {
    //   //   for (let i = 0; i < row.controls.length; i++) {
    //   //     for (let j = 0; j < row.controls[i].channels.length; j++) {
    //   //       let m = {
    //   //         m_sn: row.controls[i].sn,
    //   //         m_com: row.controls[i].com,
    //   //         m_modbus_id: row.controls[i].modbus_id,
    //   //         m_update_time: row.controls[i].update_time,
    //   //         box_sn: row.controls[i].channels[j].box_sn,
    //   //         cn: row.controls[i].channels[j].cn,
    //   //         code: row.controls[i].channels[j].code,
    //   //         dev_id: row.controls[i].channels[j].dev_id,
    //   //         i: row.controls[i].channels[j].i,
    //   //         id: row.controls[i].channels[j].id,
    //   //         sn: row.controls[i].channels[j].sn,
    //   //         stg: row.controls[i].channels[j].stg,
    //   //         type: row.controls[i].channels[j].type,
    //   //         u: row.controls[i].channels[j].u,
    //   //         update_time: row.controls[i].channels[j].update_time
    //   //       }
    //   //       this.ac_channels.push(m)
    //   //     }
    //   //   }
    //   //   this.ac_channels.sort((a, b) => {
    //   //     return a.code - b.code
    //   //   })
    //   // }
    //   // // console.log('this.ac_channels------------', this.ac_channels)
    //   //
    //   // //充电格排序
    //   // this.grids = row.grids
    //   // if (row.grids != null) {
    //   //   this.grids.sort((a, b) => {
    //   //     return a.modbus_id - b.modbus_id
    //   //   })
    //   // }
    //   //
    //   //
    //   // this.cabinets[0] = {
    //   //   bat_u: row.bat_u,
    //   //   com: row.com,
    //   //   in: row.in,
    //   //   out: row.out,
    //   //   sn: row.sn,
    //   //   sw_dt: row.sw_dt,
    //   //   wtr_lv: row.wtr_lv,
    //   //   update_time: row.update_time
    //   // }
    //   // this.$set(this.cabinets, 0, this.cabinets[0])
    //   // this.channels = null
    // }
    // ,


    parseACSwitcherStatus(val) {

      let s = ''

      if ((val & 0x0001) > 0) { //0
        s += ' 继电器开始'
      }

      if ((val & 0x0002) > 0) {//1

      }

      if ((val & 0x0004) > 0) {//2

      }

      if ((val & 0x0008) > 0) {//3

      }

      if ((val & 0x0010) > 0) {//4

      }

      if ((val & 0x0020) > 0) {//5

      }
      if ((val & 0x0040) > 0) {//6

      }
      if ((val & 0x0080 > 0)) {//7
        s += ' 继电器结束'
      }
      if ((val & 0x0100) > 0) {//8
        s += ' 红灯开启'
      }
      if ((val & 0x0200) > 0) {//9
        s += ' 绿灯开启'
      }
      if ((val & 0x0400) > 0) {//10
        s += ' 黄灯开启'
      }

      return s
    }
    ,

    parseACSwitcherError(val) {
      let s = ''

      return s
    }
    ,

    //模糊搜索
    find() {
      this.getTableData()
    }
    ,
    diffDate(start) {
      return new Date().getTime() - new Date(start).getTime()
    },

    parseWaterLevel(val) {
      let s = ""
      if ((val & 0x2000) > 0) {//13   低水位    端子口：10
        s += '-低水位'
      }
      if ((val & 0x4000) > 0) {//14  高水位    端子口：11
        s += '-高水位'
      }
      return s;
    },

    parseLedStatus(val) {

      let s = ''
      if ((val & 0x0001) > 0) { //0
        s += '红灯'
      }

      if ((val & 0x0002) > 0) {//1
        s += '绿灯'
      }

      if ((val & 0x0004) > 0) {//2
        s += '黄灯'
      }

      if ((val & 0x0100) > 0) {//8
        s += '常亮'
      }
      if ((val & 0x0200) > 0) {//9
        s += '常闭'
      }
      if ((val & 0x0400) > 0) {//10
        s += '闪烁'
      }

      if (s.length <= 0) {
        s = '常闭'
      }
      return s
    }
    ,

    parseBoxStatus(val) {

      let s = ''
      if ((val & 0x0001) > 0) { //0
        s += '直流风机故障-'
      }

      if ((val & 0x0002) > 0) {//1
        // s += '门已关闭-'
      } else {
        s += '门-'
      }

      if ((val & 0x0004) > 0) {//2
        s += '烟感报警-'
      }

      if ((val & 0x0008) > 0) {//3
        s += '电池异常-'
      }

      if ((val & 0x0100) > 0) {//8
        s += '照明灯-'
      }
      if ((val & 0x0200) > 0) {//9
        s += '电磁锁-'
      }
      if ((val & 0x0400) > 0) {//10
        s += '加热器-'
      }
      if ((val & 0x0800) > 0) {//11
        s += '交流风机-'
      }
      if ((val & 0x1000) > 0) {//12
        s += '直流风机-'
      }

      if ((val & 0x2000) > 0) {//13
        s += '红灯-'
      }

      if ((val & 0x4000) > 0) {//14
        s += '绿灯-'
      }
      if ((val & 0x8000) > 0) {//15 ledRGB蓝色
        s += '黄灯-'
      }

      if (s.length > 0) {
        s += '  开启'
      }
      return s
    }
    ,

    parseBoxError(val) {
      let s = ''
      return s
    }
    ,

    handleTerminalCmd(row) {

      this.cmdVisible = true

      let code = row.modbus_id > 0 ? (((parseInt((row.modbus_id - 10))) > 9) ? (row.modbus_id - 10) : '0' + (row.modbus_id - 10)) + '号充电仓' : '-'

      this.cmdForm = {
        code: code,
        device_type: 0,
        device_id: row.dev_id,
        box_sn: row.box_sn,
        sn: row.sn,
        cn: row.cn

      }
    }
    ,

    handleACSwitcherCmd(row) {
      this.cmdVisible = true
      let code = ''

      if (row.type == 0) {
        code = row.code.length > 0 ? ((parseInt(row.code) > 9) ? row.code : '0' + row.code) + '号充电仓' : ''
      } else {
        code = row.code.length > 0 ? row.code + '号充电插座' : ''
      }

      this.cmdForm = {
        code: code,
        device_type: 1,
        device_id: row.dev_id,
        box_sn: row.box_sn,
        sn: row.sn,
        cn: row.cn
      }
    }
    ,

    handleCmdRadio(val) {
      if (val == 'open_grid' || val == 'open_light' || val == 'close_light' || val == 'open_fan' || val == 'open_fan' || val == 'reset_ac' || val == 'reset_cli' || val == 'close_fan' || val == 'stop_charge') {
        this.isDisabled = true
      } else {
        this.cmdForm.duration = 300, //5分钟
          this.isDisabled = false
      }

      this.cmdForm = {
        code: this.cmdForm.code,
        device_type: this.cmdForm.device_type,
        device_id: this.cmdForm.device_id,
        box_sn: this.cmdForm.box_sn,
        sn: this.cmdForm.sn,
        ctrl: val,
        duration: this.cmdForm.duration,
        cn: this.cmdForm.cn
      }
    }
    ,

    handleCmdCancel() {
      this.cmdVisible = false
    }
    ,

    sendCmd() {
      this.$refs.cmdForm.validate(valid => {
        if (valid) {
          var form = Object.assign({}, this.cmdForm)

          // if (form.ctrl == 'open_grid' || form.ctrl == 'open_light' || form.ctrl == 'close_light' || form.ctrl == 'open_fan' || form.ctrl == 'open_fan' || form.ctrl == 'close_fan') {
          //   form.sn = this.cmdForm.sn
          //   form.code = this.cmdForm.code
          // }
          form.cabinetId = parseInt(form.cabinetId)

          let str = JSON.stringify(form)
          gateway({
            func: 'set_db_dev_ctrl',
            params: str
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')

            } else {
              this.$message.error('操作失败：'+res.msg)
            }
          })
        } else {
          return false
        }
      })
    }


  }

}
</script>

<style scoped>

.min {
  width: 100%;
  min-height: 200px;
  overflow: auto;
}

.one {
  width: 100%;
  min-height: 200px;
  float: left;
  overflow: auto;
}

.el-form-item {
  margin-bottom: 15px;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.blink {
  margin-top: 50 rpx;
  font-size: 36 rpx;
  color: #007AFF;
  animation: blink 1s infinite;
}

/* 选中某行时的背景色*/
/*/deep/  .el-table__body tr.current-row > td {*/
/*  background-color: #C0C4CC !important;*/
/*}*/

/*鼠标移入某行时的背景色*/
/*鼠标移入某行时的背景色*/
/deep/  .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #C0C4CC;
}

</style>